import React from 'react'
import classNames from 'classnames'
import Image from '@toasttab/shared/src/components/atoms/Image/Image'
import { NewsTwoColumnContentOptions } from '@toasttab/shared/src/utils/Contentful/richText'
import { renderRichText } from 'gatsby-source-contentful/rich-text'

interface NewsTwoColumnContentProps {
  content?: any
  image?: any
}

const NewsTwoColumnContent = ({
  content,
  image
}: NewsTwoColumnContentProps) => {
  return (
    <div
      className='py-5 w-full grid grid-cols-1 sm:grid-cols-2 grid-cols-50/50 gap-10'
      data-testid='NewsTwoColumnContent'
    >
      {content ? (
        <div>{renderRichText(content, NewsTwoColumnContentOptions)}</div>
      ) : null}
      {image ? (
        <Image
          imageAlt={image?.title}
          objectCover={false}
          url={image?.file?.url}
        />
      ) : null}
    </div>
  )
}

export default NewsTwoColumnContent
